import React from 'react';
import PropTypes from 'prop-types';
import css from './StudentIntakeHeader.scss';
import WarningMessage from './WarningMessage';

const StudentIntakeHeader = ({surveyTitle, isHopeForm, multipleStudentSurveysEnabled}) => {
    const getIntakeHeader = () => (
        <>
            {!isHopeForm && <h1> Let’s get to know you better </h1>}
            {isHopeForm
                ? (
                    <>
                        <p>You know what’s happening in college. Help make your college the best it can be for
                            you and your friends. Please tell us about your experiences by completing the
                            #RealCollege questionnaire below. It’ll take a few minutes but we think your story
                            is important.</p>
                        <p>Answering the following questions completely voluntary, you can stop answering them
                            at any time. Please click “Yes” below and answer the following questions.</p>
                    </>
                ) : <p>We want to get to know you better so we can help you achieve your goals. Please answer the questions below.</p>
            }
        </>
    );

    return (
        <>
            <section className={css['instruction-block']}>
                {multipleStudentSurveysEnabled ? <h1>{surveyTitle}</h1> : getIntakeHeader()}
            </section>
            <hr className={css['divider']}/>
            {isHopeForm && <WarningMessage message="You will not be able to view or edit this section of the survey after clicking Save."/>}
        </>
    )
};

StudentIntakeHeader.propTypes = {
    surveyTitle: PropTypes.string,
    isHopeForm: PropTypes.bool.isRequired,
    multipleStudentSurveysEnabled: PropTypes.bool
};

export default StudentIntakeHeader;
